<template>
  <div class="max-w-full">
    <NuxtLoadingIndicator
      class="bg-brand/50"
      color=""
      :height="4"
    />

    <div class="flex min-h-screen max-w-full flex-col justify-between">
      <NuxtLayout>
        <NuxtPage />
      </NuxtLayout>
    </div>
  </div>
</template>
